<template>
    <div class="href-change-box">
        <v-form-item
            :rules="formRules.appid"
            name="appid"
            error-placement="bottom"
            class="appid-item"
            label="AppID"
            desc="请从小程序开发者处获取 App ID"
            required="请正确填写AppID"
            @error="(msg)=>hanlderEerror(msg, 'appid')"
        >
            <v-input
                v-model="appletData.appid"
                :limit="APPID_INPUT_MAX_LENGTH"
                style="width:100%;"
            />
        </v-form-item>
        <v-form-item
            :rules="formRules.pagePath"
            name="pagePath"
            error-placement="bottom"
            label="PagePath"
            desc="请从小程序开发者处获取路径，如pages/index/index"
            required="请正确填写PagePath"
            @error="(msg)=>hanlderEerror(msg, 'pagePath')"
        >
            <v-input
                v-model="appletData.pagePath"
                :limit="PAGEPATH_INPUT_MAX_LENGTH"
                style="width:100%;"
            />
        </v-form-item>
    </div>
</template>

<script>
import { APPID_INPUT_MAX_LENGTH, PAGEPATH_INPUT_MAX_LENGTH, VALID_REG } from '../../constants';

const defaultValue = {
    pagePath: '',
    appid: '',
};
export default {
    props: {
        hrefVal: {
            type: Object,
            default: () => ({ ...defaultValue }),
        },
    },
    data() {
        return {
            appletData: { ...defaultValue },
            APPID_INPUT_MAX_LENGTH,
            PAGEPATH_INPUT_MAX_LENGTH,
            formRules: {
                appid: [
                    {
                        validate: (value, rule) => value !== '' && VALID_REG.wxAppId.test(value),
                        message: '请正确填写小程序appid',
                        trigger: 'change,blur',
                    },
                ],
                pagePath: [
                    {
                        validate: (value, rule) => value !== '' && VALID_REG.wxAppPath.test(value),
                        message: '请正确填写小程序pagePath',
                        trigger: 'change,blur',
                    },
                ],
            },

            /** 内部错误保持 */
            innerError: {
                ...defaultValue,
            },
        };
    },
    watch: {
        hrefVal() {
            this.initData();
        },

        appletData: {
            handler(newVal, oldVal) {
                // 注意，因为appletData是引用类型的数据，不能使用newVal与oldVal进行比较，因此采用原值进行比较
                if (JSON.stringify(this.appletData) !== JSON.stringify(this.hrefVal)) {
                    this.$emit('pushMsg', newVal);
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.initData();
    },
    beforeDestroy() {
        // 组件将被卸载时，清空对应的错误。
        this.$emit('error', '');;
    },

    methods: {
        initData() {
            if (this.hrefVal !== undefined) {
                this.appletData = { ...this.hrefVal };
            }
        },
        hanlderEerror(msg, type) {
            this.innerError[type] = msg;
            const error = Object.values(this.innerError).join('');
            this.$emit('error', error);
        },
    }
};
</script>

<style lang="less" scoped>
</style>
